import { Loader2, DollarSign, Handshake as HandshakeIcon } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';
import { Label } from '../ui/label';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';

export function CounterOfferDialog({ open, onOpenChange, selectedOffer, counterPrice, setCounterPrice, counterMessage, setCounterMessage, handleSubmitCounter, processingOfferId }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-surface border-[#262626] max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <HandshakeIcon className="w-5 h-5 text-purple-400" />
            Make Counter Offer
          </DialogTitle>
          <DialogDescription>Suggest a different price to {selectedOffer?.user_name}</DialogDescription>
        </DialogHeader>
        <div className="py-4 space-y-4">
          <div className="bg-[#1a1a1a] rounded-lg p-4">
            <div className="grid grid-cols-2 gap-4 text-sm mb-4">
              <div>
                <p className="text-[#666] mb-1">Original Price</p>
                <p className="font-mono">${selectedOffer?.original_total?.toFixed(2)}</p>
              </div>
              <div>
                <p className="text-[#666] mb-1">Their Offer</p>
                <p className="font-mono text-yellow-400">${selectedOffer?.proposed_price?.toFixed(2)}</p>
              </div>
            </div>
            <div>
              <Label className="text-sm text-[#A1A1AA]">Your Counter Price</Label>
              <div className="flex items-center gap-2 mt-2">
                <DollarSign className="w-4 h-4 text-purple-400" />
                <Input type="number" value={counterPrice} onChange={(e) => setCounterPrice(e.target.value)} className="input-dark text-lg font-bold text-purple-400" min="1" step="0.01" data-testid="counter-price-input" />
              </div>
              {counterPrice && selectedOffer && (
                <p className="text-xs text-lime mt-2">Your earnings: ${(parseFloat(counterPrice) * 0.9).toFixed(2)}</p>
              )}
            </div>
          </div>
          <div>
            <Label htmlFor="counter-message" className="text-sm text-[#A1A1AA]">Message (optional)</Label>
            <Textarea id="counter-message" value={counterMessage} onChange={(e) => setCounterMessage(e.target.value)} placeholder="Explain your counter offer..." className="input-dark mt-2" data-testid="counter-message-input" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button onClick={handleSubmitCounter} disabled={processingOfferId === selectedOffer?.id || !counterPrice} className="bg-purple-600 hover:bg-purple-700 text-white" data-testid="submit-counter-btn">
            {processingOfferId === selectedOffer?.id ? <Loader2 className="w-4 h-4 animate-spin" /> : <><HandshakeIcon className="w-4 h-4 mr-2" />Send Counter Offer</>}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
